import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom"; // Add useLocation for route detection
import { Helmet } from "react-helmet-async";
import GetInTouch from "../Components/GetInTouch";
import ScrollToTop from "../Components/ScrollToTop";
import PostAccordion from "../Components/PostAccordion";
import Prism from "prismjs";
import { FaCopy, FaCheck } from "react-icons/fa";
import "../style.css";
import "prismjs/themes/prism.css";
import "prismjs/components/prism-javascript.min.js";
import "prismjs/components/prism-css.min.js";
import "prismjs/components/prism-markup.min.js";
import YouMayAlsoLike from "./YouMayAlsoLike";
import BackToPosts from "./BackToPost";
import shopify from "../../Images/shopify.png";
import SharingButtonWithPopup from "./SharingButtonWithPopup";
import gif1 from "../../Images/instal1.gif";
import gif2 from "../../Images/insal2.gif";
import gif3 from "../../Images/instal3.gif";
import LiveComments from "./LiveComments";

const PostDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // Hook to detect route changes
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [activeTab, setActiveTab] = useState(null);

  const toggleTab = (tab) => {
    setActiveTab(activeTab === tab ? null : tab);
  };

  // Fetch post data
  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(
          `https://xebrand.in/Backend/get_single_post.php?slug=${slug}`
        );
        const data = await response.json();

        if (data.success) {
          setPost(data.post);
          setSelectedImage(data.post.image_path);
        } else {
          setError("Post not found.");
        }
      } catch (err) {
        setError("An error occurred while fetching the post.");
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  // Highlight code using Prism.js
  useEffect(() => {
    if (post && post.content) {
      Prism.highlightAll();
    }
  }, [post]);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  const handleCopy = () => {
    if (post?.content) {
      navigator.clipboard.writeText(post.content).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setSelectedVideo(null);
  };

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
    setSelectedImage(null);
  };

  if (loading) {
    return <p>Loading post details...</p>;
  }

  if (error) {
    return (
      <div>
        <h1>{error}</h1>
        <button onClick={() => navigate("/Shopify-custom-sections")}>
          Back to Posts
        </button>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`${post.name} | Free Shopify Sections by Xebrand`}</title>
        <meta
          name="description"
          content={
            post.description
              ? post.description
              : "Discover free premium Shopify sections by Xebrand. Simplify your Shopify store customization with this premium section."
          }
        />
        <link
          rel="canonical"
          href={`https://xebrand.in/Shopify-custom-sections/post/${slug}`}
        />
      </Helmet>

      <div className="post-details-wrapper">
        <BackToPosts />
        <div className="post-details">
          <div className="post-content-containerwrap">
            <div className="post-content-container-wrapper">
              <div className="post-content-container">
                <div className="post-title">
                  <h1>{post.name}</h1>
                </div>
                <SharingButtonWithPopup
                  shareUrl={`${window.location.origin}/Shopify-custom-sections/post/${post.slug}`}
                  postName={post.name}
                />
                <div className="post-img-cont">
                  {selectedImage && (
                    <img
                      src={selectedImage}
                      alt="Selected Content"
                      className="post-image"
                    />
                  )}
                  {selectedVideo && (
                    <video
                      src={selectedVideo}
                      className="post-video"
                      muted
                      loop
                      autoPlay
                    />
                  )}
                </div>
              </div>

              <div className="slider-wrapper">
                {post.image_path && (
                  <img
                    src={post.image_path}
                    alt="Main Image"
                    className={`slider-item ${
                      selectedImage === post.image_path ? "active" : ""
                    }`}
                    onClick={() => handleImageClick(post.image_path)}
                  />
                )}
                {post.video_path && (
                  <video
                    src={post.video_path}
                    className={`slider-item ${
                      selectedVideo === post.video_path ? "active" : ""
                    }`}
                    onClick={() => handleVideoClick(post.video_path)}
                    muted
                    loop
                    autoPlay
                  />
                )}
              </div>

              <div className="shape-divider-container">
                <span className="about-us">Overview</span>
                <div className="description-cont">
                  <p className="descritpion-post">
                    <p>{post.description || "No description available"}</p>
                  </p>
                  <p className="note">
                    <strong>NOTE:</strong> We currently do not provide font
                    files required for certain sections. However, we are working
                    to include font file downloads in the future.
                  </p>
                </div>
              </div>
<div className="info-accordian">
{/* <PostAccordion items={accordionData} /> */}
{/* <span className="info-guide-title">
Installation Guide
</span>
<div className="guide-cont">
<img src={gif1} alt="" />
<img src={gif1} alt="" />
<img src={gif1} alt="" />
</div> */}


</div>
              <div className="you-may-also-like">
                <YouMayAlsoLike currentPostId={post.id} />
              </div>
              <div className="comment-section destop-version">
    <LiveComments postId={post.id} />
</div>

            </div>
          </div>

          <div className="code-showcase-wrapper">
            <div className="code-source">
              <img src={shopify} alt="Tech stack Image" />
            </div>
            <div className="code-showcase">
              <div className="copy-title-tool-wrap">
                <span className="code-language">Liquid</span>
                <div className="code-copy-box" onClick={handleCopy}>
                  {copied ? (
                    <>
                      <FaCheck className="copy-icon" />{" "}
                      <span className="text-copy">Copied</span>
                    </>
                  ) : (
                    <>
                      <FaCopy className="copy-icon" />{" "}
                      <span className="text-copy">Copy Code</span>
                    </>
                  )}
                </div>
              </div>
              <pre>
                <code className="language-html">
                  {typeof post.content === "string"
                    ? post.content
                    : JSON.stringify(post.content, null, 2)}
                </code>
              </pre>
            </div>
            <div className="comment-section mobol-ver">
    <LiveComments postId={post.id} />
</div>
          </div>
        </div>
        <div className="back-button">
          <button
            onClick={() => {
              navigate("/Shopify-custom-sections");
            }}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 12H20M4 12L8 8M4 12L8 16"
                stroke="#000000"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
            Back to Showcase
          </button>
        </div>
      </div>
      <ScrollToTop />
      <GetInTouch />
    </>
  );
};

export default PostDetails;
